import * as React from 'react';
import * as AdaptiveCards from 'adaptivecards';
import { getPalette } from 'owa-fabric-theme';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import { dismissItem } from '../actions/dismissItem';
import loc from 'owa-localize';
import { activityFeedDismiss } from './WrappedAdaptiveCard.locstring.json';

const styles = require('./ActivityFeed.scss');
let classNames = require('classnames/bind').bind(styles);
interface WrappedAdaptiveCardProps {
    itemId: string;
    isSeen: boolean;
    json: any;
    onAction: (itemId: string, action: AdaptiveCards.Action) => void;
}

export function WrappedAdaptiveCard(props: WrappedAdaptiveCardProps) {
    React.useEffect(() => {
        if (container.current) {
            container.current.appendChild(createCard().render());
        }
    }, []);
    const container = React.useRef<HTMLElement>();
    const createCard = () => {
        const adaptiveCard = new AdaptiveCards.AdaptiveCard();
        const palette = getPalette();
        const { itemId, json, onAction } = props;
        adaptiveCard.hostConfig = new AdaptiveCards.HostConfig({
            fontFamily: 'Segoe UI, Helvetica Neue, sans-serif',
            containerStyles: {
                default: {
                    foregroundColors: {
                        default: {
                            default: palette.black,
                            subtle: palette.neutralSecondary,
                        },
                        accent: {
                            default: palette.themePrimary,
                        },
                    },
                },
            },
            fontSizes: {
                small: 12,
                default: 14,
            },
            fontWeights: {
                bolder: 600,
            },
        });
        adaptiveCard.onExecuteAction = action => onAction(itemId, action);
        adaptiveCard.parse(json);
        return adaptiveCard;
    };
    const onDismissItem = () => {
        dismissItem(props.itemId);
    };
    const { json } = props;

    if (json != null) {
        return (
            <div
                className={classNames(
                    styles.feedItem,
                    props.isSeen ? styles.feedItemSeen : styles.feedItemUnseen
                )}>
                <IconButton
                    className={styles.itemDismiss}
                    iconProps={{ iconName: 'Clear' }}
                    onClick={onDismissItem}
                    title={loc(activityFeedDismiss)}
                    ariaLabel={loc(activityFeedDismiss)}
                />
                <div className={styles.adaptiveContent} ref={ref => (container.current = ref)} />
            </div>
        );
    } else {
        return null;
    }
}
